export default __webpack_public_path__ + "static/media/photo-o-nas.2f669a74.jpg";